var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLait(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Milk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Milk",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30755459,10.5115516 L9.23628684,9.03656842 C10.0507366,7.74308517 10.5742404,6.28799914 10.7705303,4.77211737 L11,3 L14,3 L14.2074647,4.65971731 C14.4001716,6.20137271 14.9265656,7.68250497 15.75,9 L16.6959966,10.5135946 C16.8946611,10.8314578 17,11.198753 17,11.5735925 L17,19 C17,20.1045695 16.1045695,21 15,21 L10,21 C8.8954305,21 8,20.1045695 8,19 L8,11.5772103 C8,11.2000991 8.10661865,10.8306716 8.30755459,10.5115516 Z M8,14 L8.62829175,14.2094306 C10.1136618,14.7045539 11.747426,14.4394305 13,13.5 L13.2111456,13.3416408 C14.2465666,12.565075 15.6124342,12.4039592 16.7935841,12.9047455 L17,13 L17,19 C17,20.1045695 16.1045695,21 15,21 L10,21 C8.8954305,21 8,20.1045695 8,19 L8,14 Z M10,3 L15,3",
    id: "Combined-Shape",
    stroke: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLait);
export default __webpack_public_path__ + "static/media/lait.3ef16392bf2a975ee6f3cfc4a49a1413.svg";
export { ForwardRef as ReactComponent };